module.exports = __webpack_public_path__ + "media/assets/icons/ic-book-1f0070b53ab84c7bd2689b533a662afd.svg";